import type { FC } from 'react';
import { lazy, Suspense } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '@root/src/stores';

const ProductQuickInfoModal = lazy(async () => await import('./component'));

const ProductQuickInfoModalRoot: FC = observer(() => {
  const { modalsStore } = useStores();
  const { quickInfoProductId, quickInfoCompareMouse, closeQuickInfo } =
    modalsStore;

  if (quickInfoProductId == null) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ProductQuickInfoModal
        productId={quickInfoProductId}
        onCloseModal={closeQuickInfo}
        compareMouse={quickInfoCompareMouse}
      />
    </Suspense>
  );
});

export default ProductQuickInfoModalRoot;
